import * as THREE from "three/webgpu";

export type ViewportNavIntent = "rotate" | "pan" | "dolly" | "dolly-pan" | null;

type MouseAction = number | undefined;
type TouchAction = number | undefined;

export function navIntentFromMousePointer(
  button: number,
  modifiers: { shiftKey: boolean; metaKey: boolean; ctrlKey: boolean },
  mouseButtons: {
    LEFT?: MouseAction;
    MIDDLE?: MouseAction;
    RIGHT?: MouseAction;
  },
): ViewportNavIntent {
  const mouseAction =
    button === 0
      ? mouseButtons.LEFT
      : button === 1
        ? mouseButtons.MIDDLE
        : button === 2
          ? mouseButtons.RIGHT
          : undefined;
  if (mouseAction == null) return null;

  const modifierPan =
    modifiers.shiftKey || modifiers.metaKey || modifiers.ctrlKey;
  if (mouseAction === THREE.MOUSE.DOLLY) return "dolly";
  if (mouseAction === THREE.MOUSE.PAN) {
    return modifierPan ? "rotate" : "pan";
  }
  if (mouseAction === THREE.MOUSE.ROTATE) {
    return modifierPan ? "pan" : "rotate";
  }
  return null;
}

export function navIntentFromTouchGesture(
  touchCount: number,
  touches: { ONE?: TouchAction; TWO?: TouchAction },
): ViewportNavIntent {
  if (touchCount === 1) {
    if (touches.ONE === THREE.TOUCH.PAN) return "pan";
    if (touches.ONE === THREE.TOUCH.ROTATE) return "rotate";
    return null;
  }
  if (touchCount === 2) {
    if (touches.TWO === THREE.TOUCH.DOLLY_PAN) return "dolly-pan";
    if (touches.TWO === THREE.TOUCH.DOLLY_ROTATE) return "rotate";
    return null;
  }
  return null;
}
